import _regenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import Vue from 'vue';
import { Notification } from 'element-ui';
import axios from 'axios';
import store from "../store";
// import router from '../router' // 未使用的导入
import { getCurrentBiz } from "./bizHelper";
import { shouldRefreshToken, refreshToken } from "./token-refresh";
var request = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000
});
request.interceptors.request.use(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(config) {
    var _getCurrentBiz, bizId, bizCode, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(!store.state.app.auth_disabled && store.state.user.token)) {
            _context.n = 5;
            break;
          }
          if (!shouldRefreshToken(25 * 60 * 1000)) {
            _context.n = 4;
            break;
          }
          _context.p = 1;
          _context.n = 2;
          return refreshToken();
        case 2:
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error('[Request] Failed to refresh token before request:', _t);
        case 4:
          config.headers['X-MOA-Token'] = store.state.user.token;
          config.withCredentials = true;
        case 5:
          // 添加业务ID和业务代码到请求头
          _getCurrentBiz = getCurrentBiz(), bizId = _getCurrentBiz.bizId, bizCode = _getCurrentBiz.bizCode;
          if (bizId) {
            config.headers['X-Biz-ID'] = bizId;
          }
          if (bizCode) {
            config.headers['X-Biz-Code'] = bizCode;
          }
          return _context.a(2, config);
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  return Promise.reject(error);
});
request.interceptors.response.use(function (response) {
  var data = response.data;
  if (data.code !== 0) {
    Notification.error("".concat(data.code, ": ").concat(data.message));
    return Promise.reject(data.message);
  }
  return data['data'];
}, function (error) {
  if (error.response) {
    var data = error.response.data || {};
    if (error.response.status === 404) {
      Notification.error({
        title: '404: 目地地址不存在',
        message: data.message || ''
      });
    } else if (error.response.status === 403) {
      Notification.error({
        title: '禁止访问',
        message: data.message || ''
      });
    } else if (error.response.status === 401) {
      if (!store.state.app.auth_disabled) {
        store.dispatch('user/logout');
      } else {
        Notification.error({
          title: '没有授权',
          message: data.message || ''
        });
      }
    }
  }
  return Promise.reject(error);
});
Object.defineProperties(Vue.prototype, {
  $http: {
    get: function get() {
      return request;
    }
  }
});
export default request;